// Wave RW.2/RW.3 (2026-05-17) — /main/rfq wrapper (list / new / detail 토글)
// Wave RW.5 (2026-05-18) — URL deep link (URL = source of truth)
//   - /main/rfq          → list
//   - /main/rfq/new      → new form
//   - /main/rfq/<id>     → detail
//   - 형식 invalid (abc/0/-1/01) → list 로 replace redirect
// Dashboard.js 의 am==='rfq' 분기에서 단일 mount. lazy mount 패턴 유지.

import React, { useEffect, useMemo, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RFQList from './RFQList';
import RFQRegister from './RFQRegister';
import RFQDetail from './RFQDetail';
import { parseRfqPath } from './rfqPathParse';

function RFQPage(props) {
  var showToast = props.showToast || function(){};
  var location = useLocation();
  var navigate = useNavigate();

  var parsed = useMemo(function(){
    return parseRfqPath(location.pathname);
  }, [location.pathname]);

  // invalid 형식 (예: /main/rfq/abc) → list 로 replace. history 더럽힘 방지.
  useEffect(function(){
    if (parsed.invalid) navigate('/main/rfq', { replace: true });
  }, [parsed.invalid, navigate]);

  var goList = useCallback(function() {
    navigate('/main/rfq');
  }, [navigate]);

  var goNew = useCallback(function() {
    navigate('/main/rfq/new');
  }, [navigate]);

  var goDetail = useCallback(function(id) {
    navigate('/main/rfq/' + id);
  }, [navigate]);

  if (parsed.view === 'new' || parsed.view === 'detail') {
    return (
      <div>
        <div style={{
          padding: '12px 24px',
          borderBottom: '1px solid #e2e8f0',
          background: 'white',
          display: 'flex', alignItems: 'center',
        }}>
          <button type="button" onClick={goList} style={backBtn} title="목록으로">
            ← 목록
          </button>
        </div>
        {parsed.view === 'new' ? (
          <RFQRegister
            showToast={showToast}
            onSubmitted={function(_id){ goList(); }}
            onCancel={goList}
          />
        ) : (
          <RFQDetail
            id={parsed.id}
            showToast={showToast}
            onBack={goList}
          />
        )}
      </div>
    );
  }

  // list (default) — location.key 로 매 진입 시 remount → fresh fetch
  return <RFQList key={location.key} onNew={goNew} onSelect={goDetail} />;
}

var backBtn = {
  padding: '6px 14px',
  background: 'white', border: '1.5px solid #e2e8f0', borderRadius: 8,
  fontSize: 13, fontWeight: 600, color: '#475569',
  cursor: 'pointer',
  fontFamily: "'Pretendard',sans-serif",
};

export default RFQPage;
